import { MainProductData } from 'utils/types';
import { StyledProduct } from '../style';

function BundleProduct({
  quantityDisplay,
  images = { product: '' },
}: MainProductData) {
  return (
    <StyledProduct>
      <img src={images.product} className="mainPic" alt="main product" />
      <div className="text">
        {images.productPrefix && (
          <img
            src={images.productPrefix}
            className="prefixPic"
            alt="product prefix"
          />
        )}
        <span className="quantity">{quantityDisplay}</span>
      </div>
    </StyledProduct>
  );
}

export default BundleProduct;
